import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import RestaurantChatRoute from "./routes/RestaurantChatRoute.tsx";
import RegisterPage from "./pages/RegisterPage/RegisterPage.jsx";
import LoginPage from "./pages/LoginPage/LoginPage.jsx";
import VerifyPage from "./pages/VerifyPage/VerifyPage.jsx";
import RestaurantNotFound from "./pages/RestaurantNotFound/RestaurantNotFound.jsx";
import { AuthProvider } from "./hooks/useAuth";
import AuthHeader from "./components/AuthHeader.jsx";

function AppContent() {
    const location = useLocation();
    const isAuthPage = ['/register', '/login', '/verify'].includes(location.pathname);

    return (
        <>
            {isAuthPage && <AuthHeader />}
            <Routes>
                <Route path="/" element={<RestaurantNotFound />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/verify" element={<VerifyPage />} />
                <Route path="/:restaurantSlug/:table/chat" element={<RestaurantChatRoute />} />
                <Route path="*" element={<div style={{ padding: 20 }}>Page not found</div>} />
            </Routes>
        </>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <AppContent />
            </BrowserRouter>
        </AuthProvider>
    );
}
